
import HttpClientToken from '../../services/HttpClientToken';
import HttpClientFileToken from '../../services/HttpClientFileToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { ActualizarEstatusParams, ActualizarEstatusResponse, GuardarNotificacionParams, NotificacionConsultaParams, DetalleNotificacionResponse, DescargarNotificacionesParams, NuevaNotificacionParams, NuevaNotificacionResponse, NotificacionConsultaResponse, defaultNotificacionResponse, defaultDetalleNotificacion, defaultActualizarEstatus, defaultNotificacionConsulta } from '../../interfaces/notificaciones/NotificacionesInterface';

export const NuevaNotificacion = ( params: NuevaNotificacionParams ) => {

    return new Promise<NuevaNotificacionResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Notificacion/NuevaNotificacion', params, token)
            .then( ({ data } : { data : NuevaNotificacionResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultNotificacionResponse, message: error.message } );
            });

        }

    });

}

export const DetalleNotificacion = ( id: string ) => {

    return new Promise<DetalleNotificacionResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Notificacion/DetalleNotificacion/${ id }`, token)
            .then( ({ data } : { data : DetalleNotificacionResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultDetalleNotificacion, message: error.message } );
            });

        }

    });

}

export const GuardarNotificacion = ( params: GuardarNotificacionParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Notificacion/GuardarNotificacion', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const ActualizarEstatus = ( params: ActualizarEstatusParams ) => {

    return new Promise<ActualizarEstatusResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Notificacion/ActualizarEstatus', params, token)
            .then( ({ data } : { data : ActualizarEstatusResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultActualizarEstatus, message: error.message } );
            });

        }

    });

}

export const ConsultarNotificaciones = ( params: NotificacionConsultaParams ) => {

    return new Promise<NotificacionConsultaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if ( data ) {

            const { token } = data;

            HttpClientToken.post('/Api/Notificacion/ConsultarNotificaciones', params, token)
            .then( ({ data } : { data : NotificacionConsultaResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultNotificacionConsulta } );
            });

        }

    });

}

export const DescargarNotificaciones = ( params: DescargarNotificacionesParams ) => {

    return new Promise<Blob>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if ( data ) {

            const { token } = data;

            HttpClientFileToken.post('/Api/Notificacion/DescargarNotificaciones/', params, token)
            .then( ({ data } : { data : Blob } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( new Blob() );
            });

        }

    });

}
